// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"a6248cbb","155":"8b5136fc","217":"fc6f70e5","243":"ba3ae2d8","360":"cbf68fd7","485":"b891d3bc","684":"9b47f8e4","725":"31e9ab7f","788":"ce02ac66","827":"af09354a","861":"94f82aa3","879":"d3262db2","883":"c56e5542","902":"b09b3fb2","982":"3fafbbce","988":"0d675ae6"}[chunkId] + ".chunk.js";
};